
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/place/[id]/family/main",
      function () {
        return require("private-next-pages/place/[id]/family/main.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/place/[id]/family/main"])
      });
    }
  